import dayjs from 'dayjs';
import { Weekday } from '@frontend/api-schedule-availability';

export const MAX_WIDTH = 720;

export const DAYS_OF_WEEK = [
  Weekday.sunday,
  Weekday.monday,
  Weekday.tuesday,
  Weekday.wednesday,
  Weekday.thursday,
  Weekday.friday,
  Weekday.saturday,
] as const;

export const WeekDayName: Record<Weekday, string> = {
  [Weekday.sunday]: dayjs().set('d', 0).format('dddd'),
  [Weekday.monday]: dayjs().set('d', 1).format('dddd'),
  [Weekday.tuesday]: dayjs().set('d', 2).format('dddd'),
  [Weekday.wednesday]: dayjs().set('d', 3).format('dddd'),
  [Weekday.thursday]: dayjs().set('d', 4).format('dddd'),
  [Weekday.friday]: dayjs().set('d', 5).format('dddd'),
  [Weekday.saturday]: dayjs().set('d', 6).format('dddd'),
};

export const ShortWeekDayName: Record<Weekday, string> = {
  [Weekday.sunday]: dayjs().set('d', 0).format('ddd'),
  [Weekday.monday]: dayjs().set('d', 1).format('ddd'),
  [Weekday.tuesday]: dayjs().set('d', 2).format('ddd'),
  [Weekday.wednesday]: dayjs().set('d', 3).format('ddd'),
  [Weekday.thursday]: dayjs().set('d', 4).format('ddd'),
  [Weekday.friday]: dayjs().set('d', 5).format('ddd'),
  [Weekday.saturday]: dayjs().set('d', 6).format('ddd'),
};
